<section class="netlist-uploader" [class.drag-active]="dragActive" [class.uploading]="uploading"
  (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <div class="netlist-uploader-copy">
    <strong class="upload-title" role="button" tabindex="0" (click)="triggerBrowse()" (keydown.enter)="triggerBrowse()"
    (keydown.space)="triggerBrowse()">Upload Telesis Netlist</strong>
    <small>Drag and drop a .NET file here or browse. Max size: {{ formatBytes(maxFileSizeBytes) }}.</small>
    @if (selectedFileName) {
      <small>Selected: {{ selectedFileName }}</small>
    }
  </div>
  <input #netlistFileInput type="file" accept=".net,.NET,.txt" hidden (change)="onFileSelected($event)" />
</section>